<template>
<div id="Recycle-Player-pop1" class="My_popup">
  <div class="My_popup_wrap">
	<span class="My_popup_close" href="#" @click.prevent="closeClickHandler" style="cursor: pointer">닫기</span>
	<div class="My-popup-title">은평 인터넷방송</div>
	<div class="My-popup-content green-line">
		<div class="recycle-player-wrap">
            <div class="recycle-player">
			<div id="youtubePlayer"></div>
            </div>
		</div>
		
	</div>
  </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            playUrl: '',
            player: undefined,
            params: {
                orderColnms: ['basdt_val'],
                sortDirs: ['DESC'],
                page: 1,
                pageSize: 8
            }
        }
    },
    computed: {
        internetTvData() {
            return this.$store.getters.getInternetTvData;
        }
    },
    created() {
        this.$store.dispatch('FETCH_INTERNET_TV_LIST', this.params).then(() => {
            var url = this.$store.getters.getInternetTvData.val8;
            url = this.checkUrl(url);
            this.player = new YT.Player('youtubePlayer', {
                videoId: this.getPlayId(url),
                playerVars: {
                    'autoplay': 0, // 자동실행여부
                    'controls': 1, // 재생컨트롤 노출여부
                    'autohide': 1, // 재생컨트롤이 자동으로 사라질지의 여부
                    'rel': 0, // 동영상 재생완료 후 유사동영상 노출여부
                    'wmode': 'transparent'
                }
            });
        });
        this.$eventBus.$on("play-youtube", (url) => {
            if (typeof this.player.loadVideoById !== 'undefined') {
                this.player.loadVideoById(this.getPlayId(url), 0, "large");
            }
        });
    },
    methods: {
        youtubeUrl() {
            if (typeof this.internetTvData.val8 !== 'undefined') {
                var id = "";
                var url = this.playUrl;
                var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                var match = url.match(regExp);
                if (match && match[2].length == 11) {
                    id = match[2];
                }
                return "https://www.youtube.com/embed/" + id;
            }
        },
        getPlayId(url) {
            var id = "";
            var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
            var match = url.match(regExp);
            if (match && match[2].length == 11) {
                id = match[2];
            }
            return id;
        },
        checkUrl(url) {
            if (window.location.protocol == "http:") {
                return url.replace('https:', 'http:');
            }
            return url;
        },
        closeClickHandler() {
            this.player.stopVideo();
            this.$emit('close-main-video-win');
        }
    }
}
</script>